import React, { useState, useEffect } from "react";

const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const visibility = true;
  const handleScroll = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openWhatsapp = () => {
    const currentPath = window.location.pathname;
    const isLogoPage = currentPath === "/" || currentPath === "/logo";

    // Google Tag conversion tracking
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-667242866/rungCOCk-IUYEMnKwpAp",
      });
    }

    if (isLogoPage) {
      window.open(
        "https://api.whatsapp.com/send?phone=6282180004827&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven.",
        "_blank"
      );
    } else {
      window.open(
        "https://api.whatsapp.com/send?phone=6282188883321&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven.",
        "_blank"
      );
    }
  };

  return (
    <div>
      <div
        id="Gotop"
        className="whatsapp-button"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#25D366",
          color: "white",
          padding: "8px 12px",
          borderRadius: "50px",
          cursor: "pointer",
          fontSize: "30px",
          zIndex: 1000,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={openWhatsapp}
      >
        <i className="icofont icofont-brand-whatsapp" />
        <p
          className="whatsapp-text"
          style={{ margin: 0, marginLeft: "8px", fontSize: "16px" }}
        >
          Halo MinaLabel Saya Ingin Konsultasi
        </p>
      </div>

      <style>
        {`
        @media (max-width: 768px) {
          .whatsapp-text {
            display: none;
          }
            .whatsapp-button {
            bottom: 70px !important;
            right: 30px !important;
            height: 60px !important;
            width: 70px !important;
          }
        }
      `}
      </style>
    </div>
  );
};

export default GoToTop;
